import { combineReducers } from "redux";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import commonReducer from "./commonReducer";
import recruitmentReducer from "./recruitmentReducer";
import tabReducer from "./tabReducer";
import closedReducer from "./closedReducer";
import viewProjectTabReducer from "./viewProjectTabReducer";
import viewProjectReducer from "./viewProjectReducer";
import workflowAllCandidateReducer from "./workflowAllCandidateReducer";
import workflowShortlistReducer from "./workflowShortlistReducer";
import candidateListReducer from "./candidateReducer";
import workflowInterestCheckReducer from "./workflowInterestCheckReducer";
import suspendedReducer from "./suspendedReducer";
import workflowAssignmentReducer from "./workflowAssignmentReducer";
import workflowFunctionalReducer from "./workflowFunctionalReducer";
import workflowFlexifitReducer from "./workflowFlexifitReducer";
import workflowFinalReducer from "./workflowFinalReducer";
import projectDetailsReducer from "./projectDetailsReducer";
import requiredReducer from "./requiredReducer";

const rootReducers = combineReducers({
  auth: authReducer,
  notification: notificationReducer,
  common: commonReducer,
  tab: tabReducer,
  recruit: recruitmentReducer,
  closed: closedReducer,
  viewProjectTab: viewProjectTabReducer,
  viewProject: viewProjectReducer,
  workflowCandidate: workflowAllCandidateReducer,
  workflowShortlist: workflowShortlistReducer,
  workflowInterestCheck: workflowInterestCheckReducer,
  candidates: candidateListReducer,
  suspend: suspendedReducer,
  workflowAssignment: workflowAssignmentReducer,
  workflowFunctional: workflowFunctionalReducer,
  workflowFlexifit: workflowFlexifitReducer,
  workflowFinal: workflowFinalReducer,
  projectDetails: projectDetailsReducer,
  required: requiredReducer,
});

export default rootReducers;
